import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

class PendingTimesheet {
    constructor(
        public travelerFirstName: string,
        public travelerLastName: string,
        public unitName: string,
        public regularHours: number,
        public onCallHours: number,
        public callbackHours: number,
        public chargeHours: number,
        public totalHours: number,
        public timesheetId: string,
        public payPeriodStart: string,
        public payPeriodEnd: string,
        public timesheetComment?: string,
        public supervisorComment?: string,
        public onlineApprovalDate?: Date,
        public supervisorName?: string,
        public supervistorSignature?: string,
        public hospitalName?: string,
        public isSelected?: boolean,
    ) {}
}

class TimesheetList extends Array<PendingTimesheet> {
    constructor(elements: PendingTimesheet[] = []) {
        super();
        this.unshift(...elements);
    }

    latestStartDate?: string;

    /** @override */
    sort(): this {
        // [].sort seems to use bubble sort, which is probably "good enough" for
        // our purposes. If the timesheet list grows beyond 1000 or so
        // members, then we will need to consider a different algorithm.

        [].sort.call(this, (left: PendingTimesheet, right: PendingTimesheet) => {
            const leftUpper = left.travelerFirstName.toUpperCase();
            const rightUpper = right.travelerFirstName.toUpperCase();

            if (leftUpper < rightUpper) {
                return -1;
            } else if (leftUpper === rightUpper) {
                return 0;
            } else {
                return 1;
            }
        });

        return this;
    }

    sortByDate(): this {
        [].sort.call(this, (left: PendingTimesheet, right: PendingTimesheet) => {
            if (dayjs(left.payPeriodEnd) < dayjs(right.payPeriodEnd)) {
                return -1;
            } else if (dayjs(left.payPeriodEnd) === dayjs(right.payPeriodEnd)) {
                return 0;
            } else {
                return 1;
            }
        });

        this.latestStartDate = this[this.length - 1]?.payPeriodStart || '';

        return this;
    }

    asMap(): Map<string, PendingTimesheet> {
        const timesheetMap = new Map<string, PendingTimesheet>();

        this.forEach((el: PendingTimesheet) => {
            const { payPeriodEnd } = el;

            timesheetMap[payPeriodEnd] = timesheetMap[payPeriodEnd] || [];
            timesheetMap[payPeriodEnd].push(el);
        });

        return timesheetMap;
    }
}

const formatPayPeriod = (timestamp: Dayjs): string => {
    return dayjs.utc(timestamp).format('MM/DD/YY');
};

export { formatPayPeriod, PendingTimesheet, TimesheetList };
